import { createApiCall } from 'lib/base';

const EDIT_HOME_WIDGET_CALLOUT_CARD = 'EDIT_HOME_WIDGET_CALLOUT_CARD';

const editHomeWidgetCalloutCardApi = createApiCall<{ id: string; payload: any }>(
  EDIT_HOME_WIDGET_CALLOUT_CARD,
  ({ id, payload }) => ({
    endpoint: `api/admin/home-widget-callout-cards/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editHomeWidgetCalloutCardApi;
